import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import { FC } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useArchiveIntakeRequestMutation } from '../../redux/api/customerFormsApi'

interface Props {
  requestId: string
  handleClose: () => void
}

const DeleteDialog: FC<Props> = ({ requestId, handleClose }) => {
  const { accessToken } = useAccessTokenAndShopId()
  const [archiveRequest, { isLoading }] = useArchiveIntakeRequestMutation()

  const handleDelete = async () => {
    await archiveRequest({
      authorization: accessToken,
      requestId
    })
    handleClose()
  }

  return (
    <Dialog open={!!requestId}>
      <DialogTitle>Confirm Delete Customer Registration</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this customer registration?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="contained" disabled={isLoading} onClick={handleDelete}>
          {isLoading ? 'Sending...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteDialog
